import { adminApi } from "./adminApi";
export const driversApi = adminApi
  .enhanceEndpoints({ addTagTypes: ["Driver", "DriverMessage", "DriverAlert"] })
  .injectEndpoints({
    endpoints: (builder) => ({
      assignTripDriver: builder.mutation({
        query: ({ id, driverId }) => ({
          url: `/drivers/trips/${id}/assignment`,
          method: "PATCH",
          body: { driverId },
        }),
        invalidatesTags: ["Order"],
      }),
      getDrivers: builder.query({
        query: () => "/drivers",
        providesTags: ["Driver"],
      }),
      createDriver: builder.mutation({
        query: (body) => ({ url: "/drivers", method: "POST", body }),
        invalidatesTags: ["Driver"],
      }),
      updateDriver: builder.mutation({
        query: ({ id, ...body }) => ({
          url: `/drivers/${id}`,
          method: "PATCH",
          body,
        }),
        invalidatesTags: ["Driver"],
      }),
      getDriverConversation: builder.query({
        query: (id) => `/drivers/${id}/messages`,
        providesTags: ["DriverMessage"],
      }),
      replyToDriver: builder.mutation({
        query: ({ id, ...body }) => ({
          url: `/drivers/${id}/messages`,
          method: "POST",
          body,
        }),
        invalidatesTags: ["DriverMessage"],
      }),
      getDriverAlerts: builder.query({
        query: () => "/drivers/alerts",
        providesTags: ["DriverAlert"],
      }),
      resolveDriverAlert: builder.mutation({
        query: (id) => ({
          url: `/drivers/alerts/${id}`,
          method: "PATCH",
          body: {},
        }),
        invalidatesTags: ["DriverAlert", "DriverMessage"],
      }),
    }),
  });
export const {
  useAssignTripDriverMutation,
  useGetDriversQuery,
  useCreateDriverMutation,
  useUpdateDriverMutation,
  useGetDriverConversationQuery,
  useReplyToDriverMutation,
  useGetDriverAlertsQuery,
  useResolveDriverAlertMutation,
} = driversApi;
